<template>

    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="30%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">Confirm {{ entityType }} deletion</span>

                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text class="modal-height" style="text-align: left">

                        <span class="body-2">Deleting a {{ entityType }} will permanently remove it from the database.</span>

                    </v-card-text>

                    <v-alert :value="error" type="error" transition="scale-transition">
                        {{ errorMessage }}
                    </v-alert>


                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="confirm_role_deletion_button" class="text-none" color="red" small dark @click="onDeleteRole">Yes, delete
                            {{entityType}}
                        </v-btn>
                        <v-btn id="cancel_role_deletion_button" class="text-none" small @click="close">No, keep {{ entityType }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>


</template>

<script>

    import {EventBus} from "../../../../eventbus";
    import errormessagemanager from "../../../../managers/errormessagemanager";
    import roleinterface from "../../../../interfaces/roleinterface";

    export default {
        name: 'ConfirmRoleDeletionModal',

        data: () => ({
            entityType: "role",
            error: false,
            errorMessage: null,
        }),

        props: {
            value: Boolean,

            role: {
                roleId: Number,
                name: String,
                description: String,
                roleAppRights: Array,
                rolePoolGroupRights: Array
            }
        },

        computed: {
            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {
            async onDeleteRole() {
                this.clearAlert();
                
                let response = null;

                await roleinterface.deleteRole(this.role, requestResponse => {
                    response = requestResponse;
                });

                if (response != null && !response.error) {
                    await EventBus.$emit('roleDeletionConfirmed');

                    this.onShow = false;
                    this.role = null;
                } else {
                    errormessagemanager.getDeletionErrorMessage(response.status, message => {
                        this.errorMessage = message;
                    });
                    this.error = response.error;
                }
            },

            async close() {
                await EventBus.$emit("roleDeletionClosed");
                this.onShow = false;
                this.role = null;
                
                this.clearAlert();
            },

            clearAlert() {
                this.error = false;
                this.errorMessage = "";
            }
        }
    }
</script>

<style>
    .modal-height {
        min-height: 100px;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/roles/modals/ConfirmRoleDeletionModal.vue